import { render, staticRenderFns } from "./SocialShare.vue?vue&type=template&id=e2cbbbf8&scoped=true"
import script from "./SocialShare.vue?vue&type=script&lang=ts"
export * from "./SocialShare.vue?vue&type=script&lang=ts"
import style0 from "./SocialShare.vue?vue&type=style&index=0&id=e2cbbbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cbbbf8",
  null
  
)

export default component.exports